var keyMirror = require('keymirror');

module.exports = keyMirror({
	STACKED_AREA: null,
	STACKED_CSV: null
});